import { AxiosResponse } from 'axios'
import { PageNumberPagination } from '@/interfaces/common/PageNumberPagination'
import { ManualJournalEntryDto } from '@/interfaces/manual-journal-entries/ManualJournalEntries.dto'
import {
    BucketBalancesDto,
    WriteOffImportResultDto,
    WriteOffImportRowDto,
    WriteOffValidatedRowDto,
} from '@/interfaces/manual-journal-entries/WriteOff.dto'
import ApiService, { IRequestParameters } from '@/plugins/api-plugin/services/api.service'

export default class ManualJournalEntriesService extends ApiService {
    async getManualJournalEntries(
        params?: IRequestParameters,
    ): Promise<[ManualJournalEntryDto[], PageNumberPagination] | null> {
        return this.request<undefined, [ManualJournalEntryDto[], PageNumberPagination]>(
            'GET',
            '/manual-journal-entries',
            params,
            undefined,
            undefined,
            'getManualJournalEntries',
        ).catch(() => null)
    }

    async createManualJournalEntry(payload: any): Promise<any> {
        return this.request<any, any>(
            'POST',
            '/manual-journal-entries',
            undefined,
            payload,
            undefined,
            'createManualJournalEntry',
        ).catch(() => null)
    }

    async getWriteOffBuckets(): Promise<string[]> {
        return this.request<undefined, string[]>(
            'GET',
            '/manual-journal-entries/write-off-buckets',
            undefined,
            undefined,
            undefined,
            'getWriteOffBuckets',
        ).catch(() => [])
    }

    async getBucketBalances(reference: string): Promise<BucketBalancesDto | null> {
        return this.request<undefined, BucketBalancesDto | null>(
            'GET',
            '/manual-journal-entries/bucket-balances',
            { reference },
            undefined,
            undefined,
            'getBucketBalances',
        ).catch(() => null)
    }

    async downloadWriteOffTemplate(): Promise<AxiosResponse | null> {
        return this.request<undefined, AxiosResponse | null>(
            'GET',
            '/manual-journal-entries/write-off-template',
            undefined,
            undefined,
            'blob',
            'downloadWriteOffTemplate',
        ).catch(() => null)
    }

    async validateWriteOffs(rows: WriteOffImportRowDto[]): Promise<WriteOffValidatedRowDto[] | null> {
        return this.request<{ rows: WriteOffImportRowDto[] }, WriteOffValidatedRowDto[] | null>(
            'POST',
            '/manual-journal-entries/validate-write-offs',
            undefined,
            { rows },
            undefined,
            'validateWriteOffs',
        ).catch(() => null)
    }

    async importWriteOffs(rows: WriteOffImportRowDto[]): Promise<WriteOffImportResultDto | null> {
        return this.request<{ rows: WriteOffImportRowDto[] }, WriteOffImportResultDto | null>(
            'POST',
            '/manual-journal-entries/import-write-offs',
            undefined,
            { rows },
            undefined,
            'importWriteOffs',
        ).catch(() => null)
    }
}
